import React from 'react';
import LegalDoc from '../components/LegalDoc';

const sections = [
  {
    heading: '1. What Are Cookies?',
    paragraphs: [
      'Cookies are small text files placed on your device when you visit a website. They help the site work properly, remember your preferences, and understand how visitors use the site. Similar technologies such as pixels, tags, and local storage are also covered by this policy.',
    ],
  },
  {
    heading: '2. How We Use Cookies',
    paragraphs: [
      'We use cookies and similar technologies for the following purposes:',
    ],
    items: [
      'Essential: needed for the website to function, load pages, and keep it secure.',
      'Performance & analytics: to understand how visitors use the site so we can improve it.',
      'Functionality: to remember choices such as your preferences for a better experience.',
      'Marketing: to measure the effectiveness of our advertising and show relevant offers.',
    ],
  },
  {
    heading: '3. Analytics & Advertising Cookies (Google)',
    paragraphs: [
      'We use third-party analytics and advertising services — including Google Analytics and Google Ads — which set cookies and similar technologies. These tools help us measure website performance and deliver and measure advertising, including remarketing/retargeting (showing you relevant ads after you visit our site).',
      'Google’s use of data is governed by its own policies. You can opt out of personalized advertising through Google Ads Settings (adssettings.google.com), the Google Analytics opt-out add-on, or industry tools such as youradchoices.com and optout.aboutads.info.',
    ],
  },
  {
    heading: '4. Managing Your Cookie Preferences',
    paragraphs: [
      'You can control or delete cookies through your browser settings. Most browsers let you block cookies, delete existing ones, or alert you when a cookie is set. Please note that disabling some cookies may affect how parts of the website function.',
    ],
    items: [
      'Adjust cookie settings in your browser (Chrome, Safari, Edge, Firefox, etc.).',
      'Use your device or browser controls to limit ad tracking.',
      'Opt out of certain advertising cookies via industry tools such as youradchoices.com.',
    ],
  },
  {
    heading: '5. Changes to This Policy',
    paragraphs: [
      'We may update this Cookie Policy from time to time to reflect changes in technology or law. Updates are effective when posted on this page.',
    ],
  },
  {
    heading: '6. Contact Us',
    paragraphs: [
      'Questions about our use of cookies? Email contact@internettvservice.com or call +1 (888) 880-2585.',
    ],
  },
];

const CookiePolicy = () => (
  <LegalDoc
    eyebrow="Privacy & Data"
    title="Cookie"
    titleAccent="Policy"
    intro="This policy explains how InternetTVService uses cookies and similar technologies on this website, and the choices you have."
    updated="Last updated: 2026"
    sections={sections}
  />
);

export default CookiePolicy;
